/* GENERATED from global.src.js by build/gen_js.py - do not edit.
   The commented source is global.src.js. */
(function () {
'use strict';
var $  = function (sel, root) { return (root || document).querySelector(sel); };
var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
var rescanReveal = function () {};
var refreshSameDay = function () {};
function initMegaMenu() {
var toggles = $$('.mega__toggle');
if (!toggles.length) return;
var bar = toggles[0].closest('.mega');
var header = toggles[0].closest('.header');
var openT = null, shutT = null;
function armed() {
return toggles.some(function (t) { return t.getAttribute('aria-expanded') === 'true'; });
}
function sync() {
if (bar) bar.classList.toggle('is-armed', armed());
}
function closeAll(except) {
toggles.forEach(function (t) {
if (t !== except) {
t.setAttribute('aria-expanded', 'false');
t.parentNode.classList.remove('is-open');
}
});
sync();
}
function place(item) {
var panel = item.querySelector('.mega__panel--slim');
if (!panel || !header) return;
var hb = header.getBoundingClientRect();
var ib = item.getBoundingClientRect();
var x = Math.min(ib.left - hb.left, hb.width - panel.offsetWidth - 12);
panel.style.setProperty('--x', Math.max(12, x) + 'px');
}
function open(toggle) {
closeAll(toggle);
place(toggle.parentNode);
toggle.setAttribute('aria-expanded', 'true');
toggle.parentNode.classList.add('is-open');
toggle.parentNode.classList.add('is-lit');
sync();
}
toggles.forEach(function (toggle) {
toggle.addEventListener('click', function (e) {
e.preventDefault();
clearTimeout(openT); clearTimeout(shutT);
var isOpen = toggle.getAttribute('aria-expanded') === 'true';
if (isOpen) { closeAll(); } else { open(toggle); }
});
});
if (bar) bar.classList.add('mega--intent');
$$('.mega__top', bar || document).forEach(function (item) {
if (!item.querySelector('.mega__toggle')) {
item.addEventListener('pointerenter', function (e) {
if (e.pointerType && e.pointerType !== 'mouse') return;
clearTimeout(openT);
shutT = setTimeout(closeAll, 180);
});
return;
}
item.addEventListener('pointerenter', function (e) {
if (e.pointerType && e.pointerType !== 'mouse') return;
clearTimeout(shutT);
clearTimeout(openT);
var wait = armed() ? 0 : 90;
openT = setTimeout(function () { open(item.querySelector('.mega__toggle')); }, wait);
});
item.addEventListener('pointerleave', function (e) {
if (e.pointerType && e.pointerType !== 'mouse') return;
clearTimeout(openT);
shutT = setTimeout(closeAll, 180);
});
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape') {
clearTimeout(openT); clearTimeout(shutT);
var openToggle = toggles.filter(function (t) {
return t.getAttribute('aria-expanded') === 'true';
})[0];
closeAll();
if (openToggle) openToggle.focus();
}
});
document.addEventListener('click', function (e) {
if (!e.target.closest || !e.target.closest('.mega__top')) closeAll();
});
}
function initDrawer() {
var drawer = $('[data-drawer]');
var openBtn = $('[data-drawer-open]');
if (!drawer || !openBtn) return;
var lastFocus = null;
function open() {
lastFocus = document.activeElement;
drawer.hidden = false;
void drawer.offsetHeight;
drawer.classList.add('is-open');
openBtn.setAttribute('aria-expanded', 'true');
document.body.style.overflow = 'hidden';
var first = drawer.querySelector('a, button');
if (first) first.focus();
}
function close() {
drawer.classList.remove('is-open');
openBtn.setAttribute('aria-expanded', 'false');
document.body.style.overflow = '';
setTimeout(function () {
if (!drawer.classList.contains('is-open')) drawer.hidden = true;
}, 250);
if (lastFocus) lastFocus.focus();
}
openBtn.addEventListener('click', open);
$$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
drawer.addEventListener('click', function (e) {
if (e.target === drawer) close();          /* click the scrim */
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && !drawer.hidden) close();
});
}
function initRailAuto() {
var rails = $$('[data-rail-auto]');
if (!rails.length) return;
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
rails.forEach(function (rail) {
var dir = 1, paused = false, seen = false, idle = null, last = 0, raf = 0;
var SPEED = 14;
function auto(on) { rail.classList.toggle('is-auto', on); }
function step(now) {
raf = 0;
if (paused || !seen) return;
var max = rail.scrollWidth - rail.clientWidth;
if (max <= 1) return;
raf = requestAnimationFrame(step);
var dt = last ? Math.min((now - last) / 1000, 0.05) : 0;
last = now;
if (document.hidden) return;
var next = rail.scrollLeft + dir * SPEED * dt;
if (next <= 0) { next = 0; dir = 1; }
else if (next >= max) { next = max; dir = -1; }
rail.scrollLeft = next;
}
function run() { if (!raf) { last = 0; raf = requestAnimationFrame(step); } }
function pause(on) { paused = on; auto(!on); if (!on) run(); }
function hold(ms) {
pause(true);
clearTimeout(idle);
idle = setTimeout(function () { pause(false); }, ms || 2400);
}
rail.addEventListener('pointerenter', function () { pause(true); });
rail.addEventListener('pointerleave', function () { pause(false); });
rail.addEventListener('focusin', function () { pause(true); });
rail.addEventListener('focusout', function () { pause(false); });
rail.addEventListener('wheel', function () { hold(); }, { passive: true });
rail.addEventListener('touchstart', function () { hold(4000); }, { passive: true });
rail.addEventListener('pointerdown', function () { hold(4000); });
auto(true);
new IntersectionObserver(function (e) {
seen = e[e.length - 1].isIntersecting;
run();
}).observe(rail);
window.addEventListener('resize', run);
});
}
function initGangCalc() {
$$('[data-calc]').forEach(function (card) {
var kinds = (card.getAttribute('data-kinds') || '').split('\n')
.map(function (line) {
var p = line.split('|').map(function (x) { return x.trim(); });
if (p.length < 2) return null;
return {
key: p[0],
label: p[1],
rate: parseFloat(p[2]) || 0,
width: parseFloat(p[3]) || 0,
lens: (p[4] || '').split(',').map(Number).filter(function (n) { return n > 0; })
};
}).filter(Boolean);
if (!kinds.length) return;
var tabs = $$('[data-calc-tab]', card),
slider = card.querySelector('[data-calc-len]'),
step = card.querySelector('[data-calc-step]'),
custom = card.querySelector('[data-calc-custom]'),
cxLen = card.querySelector('[data-calc-cx-len]'),
cxWid = card.querySelector('[data-calc-cx-wid]'),
sizeEl = card.querySelector('[data-calc-size]'),
priceEl = card.querySelector('[data-calc-price]'),
sqftEl = card.querySelector('[data-calc-sqft]'),
unitEl = card.querySelector('[data-calc-unit]');
var i = 0;
function money(n) {
return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function paint(len, width, rate) {
var price = rate * len, sqft = width * len / 144;
priceEl.innerHTML = '<sup>$</sup>' + money(price);
if (sizeEl) sizeEl.innerHTML = len + '&Prime; &times; ' + width + '&Prime;';
if (sqftEl) sqftEl.innerHTML = '<b>' + sqft.toFixed(2) + '</b> sq ft';
if (unitEl) {
unitEl.innerHTML = sqft > 0
? '<b>$' + money(price / sqft) + '</b> / sq ft'
: '';
}
}
function draw() {
var k = kinds[i];
var isCustom = k.key === 'custom';
if (step) step.hidden = isCustom;
if (custom) custom.hidden = !isCustom;
if (isCustom) {
var L = Math.max(parseFloat(cxLen && cxLen.value) || 0, 0),
W = Math.max(parseFloat(cxWid && cxWid.value) || 0, 0);
paint(L, W, k.rate);
return;
}
if (!k.lens.length) return;
var n = Math.min(+slider.value, k.lens.length - 1);
slider.max = k.lens.length - 1;
slider.style.setProperty('--p', (k.lens.length > 1
? (n / (k.lens.length - 1)) * 100 : 100) + '%');
paint(k.lens[n], k.width, k.rate);
}
tabs.forEach(function (btn, n) {
btn.addEventListener('click', function () {
i = n;
tabs.forEach(function (b, m) { b.setAttribute('aria-selected', m === n ? 'true' : 'false'); });
if (slider) slider.value = 0;
draw();
});
});
if (slider) slider.addEventListener('input', draw);
[cxLen, cxWid].forEach(function (el) { if (el) el.addEventListener('input', draw); });
draw();
});
}
function initReveal() {
var items = $$('.rv-up, .pf-wipe');
if (!items.length) return;
if (!('IntersectionObserver' in window)) return;
function reveal(el) { el.classList.add('is-in'); countUp(el); }
function countUp(scope) {
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
$$('[data-count-up]', scope).forEach(function (el) {
if (el.getAttribute('data-counted')) return;
var m = /^([\d.]+)(.*)$/.exec((el.textContent || '').trim());
if (!m) return;                       /* not a figure - leave it alone */
el.setAttribute('data-counted', '1');
var whole = m[0], to = parseFloat(m[1]), sfx = m[2];
var dec = m[1].indexOf('.') > -1 ? 1 : 0;
var t0 = performance.now(), D = 1150;
(function step(now) {
var k = Math.min((now - t0) / D, 1);
el.textContent = (to * (1 - Math.pow(1 - k, 4))).toFixed(dec) + sfx;
if (k < 1) { requestAnimationFrame(step); } else { el.textContent = whole; }
})(performance.now());
});
}
function indexGridStagger() {
$$('.product-grid').forEach(function (grid) {
var cards = $$('.card--product.rv-up:not(.is-in)', grid);
if (!cards.length) return;
var tops = cards.map(function (el) { return el.getBoundingClientRect().top; });
var rowTop = null, col = 0;
cards.forEach(function (el, i) {
if (rowTop === null || Math.abs(tops[i] - rowTop) > 4) { rowTop = tops[i]; col = 0; }
el.style.setProperty('--rv-i', col > 3 ? 3 : col);
col++;
});
});
}
function revealVisible() {
$$('.rv-up, .pf-wipe').filter(function (el) { return !el.classList.contains('is-in'); }).forEach(function (el) {
var r = el.getBoundingClientRect();
if (r.top < window.innerHeight && r.bottom > 0) reveal(el);
});
}
indexGridStagger();                                 /* 0 - before anything is revealed */
revealVisible();                                    /* 1 */
var fired = false;
var io = new IntersectionObserver(function (entries) {
fired = true;
entries.forEach(function (entry) {
if (entry.isIntersecting) {
reveal(entry.target);
io.unobserve(entry.target);
}
});
}, { rootMargin: '0px 0px -8% 0px' });
items.forEach(function (el) {
if (!el.classList.contains('is-in')) io.observe(el);
});
rescanReveal = function () {
indexGridStagger();
revealVisible();
$$('.rv-up, .pf-wipe').filter(function (el) { return !el.classList.contains('is-in'); }).forEach(function (el) { io.observe(el); });
};
var reflow;
window.addEventListener('resize', function () {
clearTimeout(reflow);
reflow = setTimeout(indexGridStagger, 150);
}, { passive: true });
document.addEventListener('visibilitychange', function () {
if (!document.hidden) revealVisible();
});
window.addEventListener('pageshow', revealVisible);
setTimeout(function () {
if (fired) return;
$$('.rv-up, .pf-wipe').filter(function (el) { return !el.classList.contains('is-in'); }).forEach(reveal);
}, 3000);
document.documentElement.classList.add('rv');
}
function pad2(n) { return (n < 10 ? '0' : '') + n; }
function sameDayClock(src) {
if (!src || !window.Intl || !Intl.DateTimeFormat) return null;
var mins = parseInt(src.getAttribute('data-cutoff-min'), 10);
var zone = src.getAttribute('data-cutoff-tz');
var days = (src.getAttribute('data-cutoff-days') || '').split(',');
var closed = (src.getAttribute('data-cutoff-closed') || '').split(',');
if (isNaN(mins) || !zone || !days[0]) return null;
var partsOf;
try {
partsOf = new Intl.DateTimeFormat('en-US', {
timeZone: zone, hour12: false,
year: 'numeric', month: '2-digit', day: '2-digit',
hour: '2-digit', minute: '2-digit', second: '2-digit'
});
} catch (err) {
return null;                    // an unusable zone: keep the served wording
}
function inZone(ms) {
var o = {};
partsOf.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, mi: +o.minute, s: +o.second };
}
function cutoffAt(y, m, d) {
var guess = Date.UTC(y, m - 1, d, 0, mins, 0);
var b = inZone(guess);
return guess + (guess - Date.UTC(b.y, b.m - 1, b.d, b.h, b.mi, b.s));
}
function next(now) {
var t = inZone(now);
for (var add = 0; add < 8 + closed.length; add++) {
var day = new Date(Date.UTC(t.y, t.m - 1, t.d + add));
if (days.indexOf(String(day.getUTCDay())) === -1) continue;
var ymd = day.getUTCFullYear() + '-' + pad2(day.getUTCMonth() + 1) + '-' + pad2(day.getUTCDate());
if (closed.indexOf(ymd) !== -1) continue;
var at = cutoffAt(day.getUTCFullYear(), day.getUTCMonth() + 1, day.getUTCDate());
if (at > now) {
var b = inZone(at);
return { at: at, on: day, today: t.y === b.y && t.m === b.m && t.d === b.d };
}
}
return null;
}
return { next: next };
}
function initCutoff() {
var el = $('[data-cutoff]');
if (!el) return;
var labelEl = $('[data-cutoff-label]', el);
var timeEl = $('[data-cutoff-time]', el);
if (!labelEl || !timeEl) return;
var clock = sameDayClock($('[data-cutoff-min]'));
if (!clock) return;
var lang = document.documentElement.lang || 'en';
var dayName = new Intl.DateTimeFormat(lang, { timeZone: 'UTC', weekday: 'long' });
function render() {
var now = Date.now();
var n = clock.next(now);
if (!n) return false;
var left = Math.max(0, Math.floor((n.at - now) / 1000));
timeEl.textContent = pad2(Math.floor(left / 3600)) + ':' +
pad2(Math.floor(left / 60) % 60) + ':' + pad2(left % 60);
labelEl.textContent = n.today
? (el.getAttribute('data-cutoff-same') || '')
: (el.getAttribute('data-cutoff-next') || '').replace('[day]', dayName.format(n.on));
el.setAttribute('data-cutoff-state', n.today ? 'today' : 'ahead');
el.setAttribute('data-cutoff-at', n.at);
return true;
}
var timer = null;
function loop() { if (render() && !timer) { timer = setInterval(loop, 1000); } }
loop();
}
function initSameDay() {
var clock = sameDayClock($('[data-cutoff-min]'));
if (!clock) return;
var lang = document.documentElement.lang || 'en';
var dayName = new Intl.DateTimeFormat(lang, { timeZone: 'UTC', weekday: 'short' });
var timer = null;
function paint() {
var badges = $$('[data-sameday]');
if (!badges.length) return;
if (!timer) timer = setInterval(paint, 60000);
var n = clock.next(Date.now());
badges.forEach(function (el) {
if (!el.hasAttribute('data-sameday-rule')) el.setAttribute('data-sameday-rule', el.textContent);
var ahead = el.getAttribute('data-sameday-next') || '';
if (!n || (!n.today && !ahead)) {
el.hidden = true;
return;
}
el.hidden = false;
el.textContent = n.today
? el.getAttribute('data-sameday-rule')
: ahead.replace('[day]', dayName.format(n.on));
el.setAttribute('data-sameday-state', n.today ? 'today' : 'ahead');
});
}
refreshSameDay = paint;
paint();
document.addEventListener('visibilitychange', function () { if (!document.hidden) paint(); });
window.addEventListener('pageshow', paint);
}
function initConsent() {
var banner = $('#ConsentBanner');
if (!banner) return;
var api = window.Shopify && window.Shopify.customerPrivacy;
function alreadyDecided() {
try {
return !!(api && api.shouldShowBanner && api.shouldShowBanner() === false);
} catch (e) {
return document.cookie.indexOf('dtfv_consent=') !== -1;
}
}
if (alreadyDecided()) return;
banner.hidden = false;
function record(accepted) {
try {
if (api && api.setTrackingConsent) {
api.setTrackingConsent(accepted, function () {});
}
} catch (e) { /* fall through to the cookie */ }
document.cookie = 'dtfv_consent=' + (accepted ? 'yes' : 'no') +
';path=/;max-age=' + (60 * 60 * 24 * 180) + ';SameSite=Lax';
banner.hidden = true;
}
$$('[data-consent]', banner).forEach(function (btn) {
btn.addEventListener('click', function () {
record(btn.getAttribute('data-consent') === 'accept');
});
});
}
function initHeaderHeight() {
var header = $('[data-header]');
if (!header) return;
var nav = $('.header__nav', header);
var apply = function () {
var h = Math.round(header.getBoundingClientRect().height);
if (h > 0) document.documentElement.style.setProperty('--header-h', h + 'px');
var logo = $('.header__logo', header);
if (nav && logo) {
var ownRow = nav.offsetTop >= (logo.offsetTop + logo.offsetHeight - 2);
header.classList.toggle('header--rows', ownRow);
}
};
apply();
if (window.ResizeObserver) {
new ResizeObserver(apply).observe(header);
} else {
window.addEventListener('resize', apply, { passive: true });
}
if (document.fonts && document.fonts.ready) {
document.fonts.ready.then(apply).catch(function () {});
}
}
function initSticky() {
var header = $('[data-header]');
if (!header || !header.classList.contains('header--sticky')) return;
var onScroll = function () {
header.classList.toggle('is-stuck', window.scrollY > 8);
};
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();
}
function initRail() {
$$('[data-rail]').forEach(function (rail) {
var scope = rail.closest('section') || document;
var bar = $('[data-rail-bar]', scope);
var btns = $$('[data-rail-step]', scope);
function state() {
var max = rail.scrollWidth - rail.clientWidth;
var k = max > 0 ? rail.scrollLeft / max : 0;
var w = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
if (bar) {
bar.style.width = (w * 100) + '%';
bar.style.transform = 'translateX(' + (k * (100 / w - 100)) + '%)';
}
btns.forEach(function (b) {
var d = +b.getAttribute('data-rail-step');
b.disabled = max <= 1 || (d < 0 && rail.scrollLeft < 4) || (d > 0 && rail.scrollLeft > max - 4);
});
}
btns.forEach(function (b) {
b.addEventListener('click', function () {
rail.scrollBy({ left: (+b.getAttribute('data-rail-step')) * (rail.clientWidth * 0.8),
behavior: 'smooth' });
});
});
rail.addEventListener('scroll', function () { requestAnimationFrame(state); }, { passive: true });
window.addEventListener('resize', state);
setTimeout(state, 80);
state();
var down = false, drag = false, sx = 0, sl = 0, moved = 0;
rail.addEventListener('pointerdown', function (e) {
if (e.pointerType === 'touch' || e.button) return;
down = true; drag = false; moved = 0; sx = e.clientX; sl = rail.scrollLeft;
});
rail.addEventListener('pointermove', function (e) {
if (!down) return;
var dx = e.clientX - sx;
moved = Math.max(moved, Math.abs(dx));
if (!drag && moved > 6) {
drag = true;
rail.classList.add('is-drag');
try { rail.setPointerCapture(e.pointerId); } catch (_) {}
}
if (drag) rail.scrollLeft = sl - dx;
});
function end() { if (down) { down = false; drag = false; rail.classList.remove('is-drag'); } }
rail.addEventListener('pointerup', end);
rail.addEventListener('pointercancel', end);
rail.addEventListener('click', function (e) { if (moved > 6) e.preventDefault(); }, true);
});
}
function initFacets() {
var form = $('[data-facets]');
var sortForm = $('[data-sort-form]');
if (!form && !sortForm) return;
var resultsSel = (form && form.getAttribute('data-results')) || '#CollectionResults';
function collect() {
var params = new URLSearchParams();
if (form) {
new FormData(form).forEach(function (v, k) {
if (v !== '' && v != null) params.append(k, v);
});
}
var sel = $('[data-sort]');
if (sel && sel.value) params.set('sort_by', sel.value);
return params;
}
function apply() {
var params = collect();
var url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
var busy = form || sortForm;
busy.classList.add('is-busy');
fetch(url)
.then(function (r) { return r.text(); })
.then(function (html) {
var doc = new DOMParser().parseFromString(html, 'text/html');
var fresh = doc.querySelector(resultsSel);
var current = document.querySelector(resultsSel);
if (fresh && current) current.innerHTML = fresh.innerHTML;
var freshForm = doc.querySelector('[data-facets]');
if (freshForm && form) form.innerHTML = freshForm.innerHTML;
var freshCount = doc.querySelector('[data-result-count]');
var count = document.querySelector('[data-result-count]');
if (freshCount && count) count.textContent = freshCount.textContent;
var freshFacetCount = doc.querySelector('[data-facet-count]');
var facetCount = document.querySelector('[data-facet-count]');
if (freshFacetCount && facetCount) {
facetCount.textContent = freshFacetCount.textContent;
facetCount.setAttribute('data-count',
freshFacetCount.getAttribute('data-count') || '0');
}
rescanReveal();   /* same task as the swap: no frame at opacity:0 */
refreshSameDay(); /* new cards: the served rule until repainted */
window.history.replaceState({}, '', url);
})
.catch(function () { (form || sortForm).submit(); })
.then(function () { busy.classList.remove('is-busy'); });
}
if (form) {
form.addEventListener('change', apply);
form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
form.addEventListener('click', function (e) {
var btn = e.target.closest && e.target.closest('[data-facet-more]');
if (!btn) return;
var list = btn.previousElementSibling;
if (!list) return;
var open = list.classList.toggle('is-expanded');
btn.setAttribute('aria-expanded', open ? 'true' : 'false');
btn.textContent = btn.getAttribute(open ? 'data-less' : 'data-more') || btn.textContent;
});
}
if (sortForm) {
sortForm.addEventListener('change', apply);
sortForm.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
}
var sortUI = $('[data-sortui]');
var sortSel = $('[data-sort]');
if (sortUI && sortSel && sortSel.form) {
var sortBtn = $('[data-sortui-btn]', sortUI);
var sortMenu = $('[data-sortui-menu]', sortUI);
var sortValue = $('[data-sortui-value]', sortUI);
var openSort = function (state) {
state = !!state;
if (state === sortUI.classList.contains('is-open')) return;
sortUI.classList.toggle('is-open', state);
sortBtn.setAttribute('aria-expanded', state ? 'true' : 'false');
if (window.matchMedia('(max-width: 900px)').matches) {
document.body.style.overflow = state ? 'hidden' : '';
}
};
var syncSort = function () {
var opt = sortSel.options[sortSel.selectedIndex];
if (opt) sortValue.textContent = opt.text;
$$('[data-sort-option]', sortMenu).forEach(function (b) {
b.setAttribute('aria-pressed',
b.getAttribute('data-sort-option') === sortSel.value ? 'true' : 'false');
});
};
sortBtn.addEventListener('click', function () {
openSort(!sortUI.classList.contains('is-open'));
});
sortMenu.addEventListener('click', function (e) {
var opt = e.target.closest('[data-sort-option]');
if (!opt) return;
sortSel.value = opt.getAttribute('data-sort-option');
syncSort();
openSort(false);
sortBtn.focus();
sortSel.dispatchEvent(new Event('change', { bubbles: true }));
});
document.addEventListener('click', function (e) {
if (!sortUI.contains(e.target) || e.target === sortUI) openSort(false);
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && sortUI.classList.contains('is-open')) {
openSort(false);
sortBtn.focus();
}
});
sortSel.addEventListener('change', syncSort);
sortSel.form.classList.add('sort--ui');
sortUI.hidden = false;
syncSort();
}
var drawer = $('[data-facet-drawer]');
var openBtn = $('[data-facet-drawer-open]');
if (drawer && openBtn) {
var panel = $('[data-facet-panel]', drawer) || drawer;
var lastFocus = null;
function focusables() {
return $$('a[href], button:not([disabled]), input:not([disabled]), select, summary, [tabindex]:not([tabindex="-1"])', panel)
.filter(function (el) { return el.offsetParent !== null; });
}
function isOpen() { return drawer.classList.contains('is-open'); }
function openDrawer() {
lastFocus = document.activeElement;
drawer.classList.add('is-open');
openBtn.setAttribute('aria-expanded', 'true');
document.body.style.overflow = 'hidden';
var first = focusables()[0];
if (first) first.focus();
}
function closeDrawer() {
drawer.classList.remove('is-open');
openBtn.setAttribute('aria-expanded', 'false');
document.body.style.overflow = '';
if (lastFocus && lastFocus.focus) lastFocus.focus();
}
openBtn.addEventListener('click', openDrawer);
drawer.addEventListener('click', function (e) { if (e.target === drawer) closeDrawer(); });
document.addEventListener('click', function (e) {
if (e.target.closest && e.target.closest('[data-facet-drawer-close]')) closeDrawer();
});
document.addEventListener('keydown', function (e) {
if (!isOpen()) return;
if (e.key === 'Escape') { closeDrawer(); return; }
if (e.key !== 'Tab') return;
var items = focusables();
if (!items.length) return;
var first = items[0], last = items[items.length - 1];
if (items.indexOf(document.activeElement) === -1) {
e.preventDefault();
(e.shiftKey ? last : first).focus();
} else if (e.shiftKey && document.activeElement === first) {
e.preventDefault();
last.focus();
} else if (!e.shiftKey && document.activeElement === last) {
e.preventDefault();
first.focus();
}
});
}
}
function money(cents) {
return '$' + (cents / 100).toFixed(2);
}
function initProduct() {
var root = $('[data-product]');
if (!root) return;
var main = $('[data-gallery-main]');
var thumbs = $$('[data-gallery-thumb]');
function showThumb(thumb) {
var src = thumb.getAttribute('data-src');
if (main && src) {
main.srcset = thumb.getAttribute('data-srcset') || '';
main.alt = thumb.getAttribute('data-alt') || '';
['width', 'height'].forEach(function (key) {
var size = thumb.getAttribute('data-' + key);
if (size) main.setAttribute(key, size);
});
main.src = src;
}
thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
thumb.setAttribute('aria-current', 'true');
}
thumbs.forEach(function (thumb) {
thumb.addEventListener('click', function () { showThumb(thumb); });
});
function showMedia(id) {
var thumb = id && thumbs.filter(function (t) { return t.getAttribute('data-media') === String(id); })[0];
if (!thumb) return;
showThumb(thumb);
var rail = thumb.parentNode;
rail.scrollTop = thumb.offsetTop - rail.offsetTop;
rail.scrollLeft = thumb.offsetLeft - rail.offsetLeft;
}
var dataEl = $('[data-product-variants]');
var variants = [];
try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
var idField = $('[data-variant-id]');
var addLabel = $('[data-add-label]');
var addBtn = $('.pbtn--cart');
function currentOptions() {
return $$('[data-option-select]').map(function (sel) { return sel.value; });
}
function matchVariant() {
var chosen = currentOptions();
if (!chosen.length) return variants[0];
return variants.filter(function (v) {
return v.options.length === chosen.length &&
v.options.every(function (o, i) { return o === chosen[i]; });
})[0];
}
function askVariant() {
var want = currentOptions().join('|');
var ids = $$('[data-option-select]').map(function (s) {
return s.options[s.selectedIndex].getAttribute('data-vid');
});
fetch(location.pathname + '?option_values=' + ids.join(',') + '&section_id=' + dataEl.getAttribute('data-section'))
.then(function (r) { return r.text(); })
.then(function (html) {
var m = /data-variant-picked>([^<]+)</.exec(html);
var v = m && JSON.parse(m[1]);
if (v && v.options.join('|') === want && currentOptions().join('|') === want) {
variants.push(v);
applyVariant();
showMedia(v.featured);
}
})
.catch(function () {});
}
function applyVariant() {
var v = matchVariant();
if (!v) {
if (addBtn) addBtn.disabled = true;
if (dataEl && dataEl.hasAttribute('data-capped')) askVariant();
return;
}
if (idField) idField.value = v.id;
if (addBtn) addBtn.disabled = !v.available;
$$('[data-price]').forEach(function (el) { el.textContent = money(v.price); });
priceForQty();
if (!tiers || packLadder) {
var ea = $('[data-tier-price]');
if (ea) { roll(ea, v.price, money); }
lineTotal(v.price);
}
}
function showChoice(sel) {
var v = matchVariant();
var i = +sel.getAttribute('data-option-index');
if (!v || !v.featured) {
v = variants.filter(function (x) { return x.featured && x.options[i] === sel.value; })[0];
}
if (v) showMedia(v.featured);
}
$$('[data-option-select]').forEach(function (sel) {
sel.addEventListener('change', function () { applyVariant(); showChoice(sel); });
});
function pressGroup(buttons, active) {
buttons.forEach(function (b) {
b.setAttribute('aria-pressed', b === active ? 'true' : 'false');
});
}
$$('[data-opt-value]').forEach(function (btn) {
btn.addEventListener('click', function () {
var idx = btn.getAttribute('data-opt-index');
var sel = $('[data-option-select][data-option-index="' + idx + '"]');
if (!sel) return;
sel.value = btn.getAttribute('data-opt-value');
pressGroup($$('[data-opt-value][data-opt-index="' + idx + '"]'), btn);
sel.dispatchEvent(new Event('change', { bubbles: true }));
});
});
$$('[data-opt-slider]').forEach(function (slider) {
var idx = slider.getAttribute('data-opt-index');
var sel = $('[data-option-select][data-option-index="' + idx + '"]');
var ticks = $$('[data-opt-ticks="' + idx + '"] > *');
var note = $('[data-slider-note="' + idx + '"]');
function paintTrack() {
var pct = slider.max > 0 ? (slider.value / slider.max) * 100 : 0;
slider.style.setProperty('--p', pct + '%');
}
function apply(dispatch) {
if (!sel) return;
var i = +slider.value;
var opt = sel.options[i];
if (!opt) return;
sel.value = opt.value;
var tick = ticks[i];
ticks.forEach(function (t) { t.classList.remove('on'); });
if (tick) { tick.classList.add('on'); if (note) { note.textContent = tick.textContent; } }
paintTrack();
if (dispatch) { sel.dispatchEvent(new Event('change', { bubbles: true })); }
}
slider.addEventListener('input', function () { apply(false); });
slider.addEventListener('change', function () { apply(true); });
paintTrack();
});
$$('[data-prop-value]').forEach(function (btn) {
btn.addEventListener('click', function () {
var sel = document.getElementById(btn.getAttribute('data-prop-for'));
if (!sel) return;
sel.value = btn.getAttribute('data-prop-value');
pressGroup($$('[data-prop-for="' + btn.getAttribute('data-prop-for') + '"]'), btn);
});
});
var qtyInput = $('[data-qty-input]');
var qtyTarget = qtyInput ? (+qtyInput.value || 1) : 1;
var REDUCE = window.matchMedia &&
window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function roll(el, to, fmt) {
if (!el) return;
var isInput = el.tagName === 'INPUT';
var read = isInput ? el.value : el.textContent;
var from = parseFloat(String(read).replace(/[^0-9.]/g, ''));
function put(v) { if (isInput) { el.value = v; } else { el.textContent = v; } }
put(fmt(to));
if (REDUCE || !window.requestAnimationFrame) return;
if (!isFinite(from) || from === to) return;
if (isInput && document.activeElement === el) return;   /* they are typing */
if (el._roll) { cancelAnimationFrame(el._roll); }
var t0 = 0;
el._roll = requestAnimationFrame(function step(ts) {
t0 = t0 || ts;
var k = Math.min(1, (ts - t0) / 150);
put(fmt(from + (to - from) * k));
if (k < 1) { el._roll = requestAnimationFrame(step); } else { el._roll = 0; put(fmt(to)); }
});
}
function setQty(n) {
if (!qtyInput) return;
qtyTarget = Math.max(1, n | 0);
roll(qtyInput, qtyTarget, function (v) { return String(Math.round(v)); });
priceForQty();
if (!tiers || packLadder) { lineTotal(); }
}
var up = $('[data-qty-up]'), down = $('[data-qty-down]');
if (up) up.addEventListener('click', function () { setQty(qtyTarget + 1); });
if (down) down.addEventListener('click', function () { setQty(qtyTarget - 1); });
if (qtyInput) qtyInput.addEventListener('change', function () { setQty(+qtyInput.value || 1); });
var tierRoot = $('[data-tiers]');
var tiers = null, tierBase = 0;
var saveLabel = tierRoot ? (tierRoot.getAttribute('data-tier-save') || '') : '';
var nudgeLabel = tierRoot ? (tierRoot.getAttribute('data-tier-nudge-label') || '') : '';
var packLadder = false;
if (tierRoot) {
var tierEl = $('[data-tier-data]');
try { tiers = JSON.parse(tierEl.textContent); } catch (e) { tiers = null; }
if (!tiers || !tiers.length) {
tiers = null;
tierRoot.hidden = true;    /* no ladder is better than a guessed one */
} else {
tierBase = tiers[0].p;
packLadder = tiers.every(function (t) { return t.opt; });
renderTierTable();
priceForQty();             /* the current tier is highlighted at load */
}
}
function selectOptionValue(value) {
var sels = $$('[data-option-select]');
for (var i = 0; i < sels.length; i++) {
var sel = sels[i];
for (var j = 0; j < sel.options.length; j++) {
if (sel.options[j].value === value) {
sel.value = value;
var idx = sel.getAttribute('data-option-index');
var chip = $('[data-opt-value="' + value.replace(/"/g, '\\"') + '"][data-opt-index="' + idx + '"]');
if (chip) { pressGroup($$('[data-opt-value][data-opt-index="' + idx + '"]'), chip); }
sel.dispatchEvent(new Event('change', { bubbles: true }));
return true;
}
}
}
return false;
}
function tierFor(q) {
if (!tiers) return null;
for (var i = 0; i < tiers.length; i++) {
if (q >= tiers[i].min && q <= tiers[i].max) return tiers[i];
}
return q < tiers[0].min ? tiers[0] : tiers[tiers.length - 1];
}
function savePct(p) { return Math.round((tierBase - p) / tierBase * 100); }
function group(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
function renderTierTable() {
var table = $('[data-tier-table]');
if (!table) return;
var rows = tiers.map(function (t) {
var span = t.opt ? t.opt
: t.max >= 999999 ? group(t.min) + '+'
: group(t.min) + ' \u2013 ' + group(t.max);
var optAttr = t.opt ? ' data-tier-opt="' + String(t.opt).replace(/"/g, '&quot;') + '"' : '';
return '<tr data-qty="' + t.min + '"' + optAttr + '><th scope="row">' +
'<button type="button" class="vol__row" data-qty-tier="' + t.min + '">' +
span + '</button></th>' +
'<td>' + money(Math.round(t.p * 100)) + '</td></tr>';
}).join('');
table.innerHTML = rows;
$$('tr[data-qty]', table).forEach(function (tr) {
tr.addEventListener('click', function () {
var opt = tr.getAttribute('data-tier-opt');
if (opt) { selectOptionValue(opt); }
else { setQty(+tr.getAttribute('data-qty')); }
});
});
}
function priceForQty() {
if (!tiers) return;
if (packLadder) {
var chosen = currentOptions();
$$('tr[data-qty]').forEach(function (tr) {
var opt = tr.getAttribute('data-tier-opt');
var live = !!opt && chosen.indexOf(opt) !== -1;
tr.classList.toggle('on', live);
tr.classList.toggle('is-current', live);
var b = tr.querySelector('.vol__row');
if (b) { b.setAttribute('aria-current', live ? 'true' : 'false'); }
});
var packNudge = $('[data-tier-nudge]');
if (packNudge) { packNudge.hidden = true; }
return;
}
var q = qtyTarget;
var t = tierFor(q);
$$('tr[data-qty]').forEach(function (tr) {
var live = +tr.getAttribute('data-qty') === t.min;
tr.classList.toggle('on', live);
tr.classList.toggle('is-current', live);
var btn = tr.querySelector('.vol__row');
if (btn) { btn.setAttribute('aria-current', live ? 'true' : 'false'); }
});
roll($('[data-tier-price]'), t.p * 100, function (c) { return money(Math.round(c)); });
lineTotal(t.p * 100);
var nudge = $('[data-tier-nudge]');
var next = tiers[tiers.indexOf(t) + 1];
if (nudge) {
if (next && nudgeLabel) {
var pct = savePct(next.p);
nudge.hidden = false;
nudge.textContent = nudgeLabel
.replace('%n', function () { return group(next.min - q); })
.replace('%p', function () { return money(Math.round(next.p * 100)); }) +
(pct > 0 && saveLabel ? ' — ' + saveLabel.replace('%s', pct) : '');
} else {
nudge.hidden = true;
}
}
}
function lineTotal(unitCents) {
var q = qtyTarget;
var unit = unitCents;
if (unit === undefined || unit === null) {
unit = parseFloat(String(($('[data-tier-price]') || {}).textContent || '')
.replace(/[^0-9.]/g, '')) * 100;
}
if (!isFinite(unit)) return;
$$('[data-line-total]').forEach(function (el) {
roll(el, unit * q, function (c) { return money(Math.round(c)); });
});
var note = $('[data-qty-note]');
if (note) { note.textContent = q + ' ' + (q === 1 ? 'pc' : 'pcs'); }
var meta = $('[data-sbar-meta]');
if (meta) { meta.textContent = q + ' \u00d7 ' + money(Math.round(unit)) + ' each'; }
}
var stage = $('[data-stage]');
if (stage) {
var surfaceName = $('[data-surface-name]');
$$('[data-swatch]').forEach(function (btn) {
btn.addEventListener('click', function () {
stage.style.background = btn.getAttribute('data-swatch');
if (surfaceName) { surfaceName.textContent = btn.getAttribute('data-name') || ''; }
$$('[data-swatch]').forEach(function (b) {
b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
});
});
});
}
var pills = $$('[data-context]');
if (stage && pills.length) {
var stageImg = $('.stage__patch', stage);
var stageCap = $('[data-stage-cap]');
pills.forEach(function (pill) {
pill.addEventListener('click', function () {
var src = pill.getAttribute('data-context-src');
var alt = pill.getAttribute('data-context-alt');
var cap = pill.getAttribute('data-context-cap');
if (src && stageImg) {
stageImg.src = src;
if (alt) { stageImg.alt = alt; }
}
if (cap && stageCap) { stageCap.textContent = cap; }
pills.forEach(function (p) {
p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
});
});
});
}
var altSel = $('[data-alt-view-select]');
var altImg = $('[data-alt-view]');
if (altSel && altImg) {
altSel.addEventListener('change', function () {
var opt = altSel.options[altSel.selectedIndex];
altImg.src = altSel.value;
var alt = opt && opt.getAttribute('data-alt');
if (alt !== null && alt !== undefined) { altImg.alt = alt; }
});
}
var upload = $('[data-artwork-upload]');
if (upload) {
var hint = $('[data-upload-hint]');
var hintText = hint ? hint.textContent : '';
var dz = upload.closest('.dz');
function dzState(s) { if (dz) { dz.setAttribute('data-s', s); } }
upload.addEventListener('change', function () {
var f = upload.files && upload.files[0];
upload.removeAttribute('aria-invalid');
if (!hint) return;
hint.classList.remove('is-error');
if (!f) { hint.textContent = hintText; dzState('rest'); return; }
var maxMb = +upload.getAttribute('data-max-mb') || 20;
var accept = (upload.getAttribute('accept') || '').split(',')
.map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
var ext = '.' + f.name.split('.').pop().toLowerCase();
if (accept.length && accept.indexOf(ext) === -1) {
hint.classList.add('is-error');
hint.textContent = 'That file type is not accepted. Use one of: ' + accept.join(', ');
upload.value = '';
dzState('error');
} else if (f.size > maxMb * 1024 * 1024) {
hint.classList.add('is-error');
hint.textContent = 'That file is larger than ' + maxMb + 'MB. Please compress it' +
(upload.required ? ' and upload it again.' : ' or send it after ordering.');
upload.value = '';
dzState('error');
} else {
hint.textContent = f.name + ' \u2713';
dzState('done');
}
});
if (dz) {
var dragDepth = 0;   /* dragenter/dragleave fire per child crossed, not per zone */
['dragenter', 'dragover'].forEach(function (evt) {
dz.addEventListener(evt, function (e) {
e.preventDefault();
if (evt === 'dragenter') { dragDepth++; }
dzState('drag');
});
});
dz.addEventListener('dragleave', function () {
dragDepth = Math.max(0, dragDepth - 1);
if (dragDepth === 0) { dzState(upload.files.length ? 'done' : 'rest'); }
});
dz.addEventListener('drop', function (e) {
e.preventDefault();
dragDepth = 0;
var files = e.dataTransfer && e.dataTransfer.files;
if (files && files.length) {
upload.files = files;
upload.dispatchEvent(new Event('change', { bubbles: true }));
} else {
dzState('rest');
}
});
}
}
var sticky = $('[data-sticky-atc]');
var buyForm = $('#ProductForm');
if (sticky && buyForm && 'IntersectionObserver' in window) {
var mainAdd = function () {
var a = $$('[name=add]', buyForm).filter(function (b) {
return b.offsetWidth && getComputedStyle(b).visibility !== 'hidden';
});
return a.length === 1 && !a[0].disabled && a[0];
};
sticky.hidden = false;
new IntersectionObserver(function (entries) {
var e = entries[0];
sticky.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0 && !!mainAdd());
}, { rootMargin: '0px 0px 99999px' }).observe(buyForm);
$('button', sticky).addEventListener('click', function (e) {
var b = mainAdd();
e.preventDefault();
if (b) b.click();
});
}
if (idField) { applyVariant(); }
}
function initCart() {
var drawer = $('[data-cart-drawer]');
if (!drawer) return;
var body = $('[data-cart-body]', drawer);
var lastFocus = null;
function open() {
lastFocus = document.activeElement;
drawer.hidden = false;
void drawer.offsetHeight;              /* flush layout; never wait on rAF */
drawer.classList.add('is-open');
document.body.style.overflow = 'hidden';
var f = drawer.querySelector('button, a, input');
if (f) f.focus();
}
function close() {
drawer.classList.remove('is-open');
document.body.style.overflow = '';
setTimeout(function () {
if (!drawer.classList.contains('is-open')) drawer.hidden = true;
}, 250);
if (lastFocus) lastFocus.focus();
}
function refresh() {
return fetch(window.location.origin + '/cart')
.then(function (r) { return r.text(); })
.then(function (html) {
var doc = new DOMParser().parseFromString(html, 'text/html');
var fresh = doc.querySelector('[data-cart-body]');
if (fresh && body) { body.innerHTML = fresh.innerHTML; rescanReveal(); }
var count = doc.querySelector('[data-cart-count]');
if (count) {
$$('[data-cart-count]').forEach(function (el) { el.textContent = count.textContent; });
}
});
}
var DEBOUNCE_MS = 400;
var SPINNER_AFTER_MS = 800;
var lines = {};
function fmtMoney(cents) {
var host = document.querySelector('[data-currency]');
var iso = (host && host.getAttribute('data-currency')) || 'USD';
try {
return new Intl.NumberFormat(document.documentElement.lang || 'en', {
style: 'currency', currency: iso
}).format(cents / 100);
} catch (e) {
return '$' + (cents / 100).toFixed(2);
}
}
function itemEls(key) {
var sel = window.CSS && CSS.escape ? CSS.escape(key) : key;
return $$('[data-cart-item][data-key="' + sel + '"]');
}
function qtyOf(li) {
var i = $('[data-cart-qty]', li);
return +(i && i.value) || 0;
}
function paintSubtotal() {
var total = 0, seen = {};
$$('[data-cart-item]').forEach(function (li) {
var k = li.getAttribute('data-key');
if (seen[k]) return;                      /* drawer + page share keys */
seen[k] = 1;
total += (+li.getAttribute('data-unit-price') || 0) * qtyOf(li);
});
$$('[data-cart-subtotal]').forEach(function (el) { el.textContent = fmtMoney(total); });
}
function paintCount() {
var n = 0, seen = {};
$$('[data-cart-item]').forEach(function (li) {
var k = li.getAttribute('data-key');
if (seen[k]) return;
seen[k] = 1;
n += qtyOf(li);
});
$$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
}
function paintLine(key, qty) {
itemEls(key).forEach(function (li) {
var input = $('[data-cart-qty]', li);
if (input) input.value = qty;
var price = $('[data-line-price]', li);
if (price) {
price.textContent = fmtMoney((+li.getAttribute('data-unit-price') || 0) * qty);
}
});
var esc = window.CSS && CSS.escape ? CSS.escape(key) : key;
$$('[data-cart-qty-mirror][data-key="' + esc + '"]').forEach(function (h) {
h.value = qty;
});
paintSubtotal();
paintCount();
}
function flash(key, cls) {
itemEls(key).forEach(function (li) {
li.classList.add(cls);
setTimeout(function () { li.classList.remove(cls); }, 1200);
});
}
function busy(key, on) {
itemEls(key).forEach(function (li) { li.classList.toggle('is-busy', !!on); });
}
var seqCounter = 0;
function flush(key) {
var st = lines[key];
if (!st || st.inflight) return;             /* completion will re-flush */
var seq = ++seqCounter;
st.seq = seq;
st.sent = st.desired;
st.inflight = true;
clearTimeout(st.spinner);
st.spinner = setTimeout(function () { busy(key, true); }, SPINNER_AFTER_MS);
fetch('/cart/change.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ id: key, quantity: st.sent })
})
.then(function (r) {
if (!r.ok) throw new Error('cart ' + r.status);
return r.json();
})
.then(function (cart) {
st.inflight = false;
clearTimeout(st.spinner);
busy(key, false);
if (seq !== st.seq) return;             /* stale - a newer request won */
if (st.desired !== st.sent) {           /* clicks arrived mid-flight */
flush(key);
return;
}
var line = (cart.items || []).filter(function (i) { return i.key === key; })[0];
if (!line) { delete lines[key]; return refresh(); }
if (line.quantity !== st.desired) {
paintLine(key, line.quantity);
flash(key, 'is-corrected');
}
st.desired = line.quantity;
st.before = line.quantity;
$$('[data-cart-subtotal]').forEach(function (el) {
el.textContent = fmtMoney(cart.total_price);
});
$$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
delete lines[key];
if ($('[data-ship-bar]')) refresh();
})
.catch(function () {
st.inflight = false;
clearTimeout(st.spinner);
busy(key, false);
if (seq !== st.seq) return;
paintLine(key, st.before);              /* revert to the known-good qty */
flash(key, 'is-reverted');
delete lines[key];
});
}
function change(key, quantity) {
var els = itemEls(key);
if (!els.length) {                          /* not on screen - plain call */
return fetch('/cart/change.js', {
method: 'POST', headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: key, quantity: quantity })
}).then(refresh);
}
var st = lines[key];
if (!st) st = lines[key] = { before: qtyOf(els[0]) };
st.desired = quantity;
paintLine(key, quantity);                   /* optimistic, immediate */
clearTimeout(st.timer);
st.timer = setTimeout(function () { flush(key); }, DEBOUNCE_MS);
return Promise.resolve();
}
document.addEventListener('submit', function (e) {
var form = e.target;
if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
e.preventDefault();
if (form.hasAttribute('data-mx-form')) return;
var btn = form.querySelector('[type="submit"]');
if (btn) {
btn.classList.add('is-busy');
btn.setAttribute('aria-busy', 'true');
btn.disabled = true;
}
var release = function () {
if (btn) {
btn.classList.remove('is-busy');
btn.removeAttribute('aria-busy');
btn.disabled = false;
}
};
var stale = form.querySelector('[data-add-error]');
if (stale) stale.remove();
fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
.then(function (r) {
return r.json().then(function (d) {
if (!r.ok) throw { rejected: true, description: d && (d.description || d.message) };
return d;
});
})
.then(function () { return refresh(); })
.then(function () { release(); bumpCount(); open(); })
.catch(function (err) {
release();
if (!err || !err.rejected) return form.submit();   /* fall back to a real post */
var box = document.createElement('div');
box.className = 'form-errors';
box.setAttribute('role', 'alert');
box.setAttribute('data-add-error', '');
box.textContent = err.description || drawer.getAttribute('data-add-error-text') || '';
if (btn) btn.insertAdjacentElement('afterend', box);
else form.appendChild(box);
});
});
document.addEventListener('dtf:cart-add', function () {
refresh().then(function () { bumpCount(); open(); });
});
function bumpCount() {
$$('[data-cart-count]').forEach(function (el) {
el.classList.remove('is-bumped');
void el.offsetWidth;                /* restart the animation on a re-add */
el.classList.add('is-bumped');
});
}
document.addEventListener('click', function (e) {
var t = e.target;
if (!t.closest) return;
if (t.closest('[data-cart-close]')) return close();
var item = t.closest('[data-cart-item]');
if (!item) return;
var key = item.getAttribute('data-key');
var input = $('[data-cart-qty]', item);
if (t.closest('[data-cart-plus]'))  change(key, (+input.value || 0) + 1);
if (t.closest('[data-cart-minus]')) change(key, Math.max(0, (+input.value || 0) - 1));
if (t.closest('[data-cart-remove]')) change(key, 0);
});
document.addEventListener('change', function (e) {
var item = e.target.closest && e.target.closest('[data-cart-item]');
if (item && e.target.matches('[data-cart-qty]')) {
change(item.getAttribute('data-key'), Math.max(0, +e.target.value || 0));
}
});
var noteTimer = null;
document.addEventListener('input', function (e) {
if (!e.target.matches || !e.target.matches('[data-cart-note]')) return;
clearTimeout(noteTimer);
var val = e.target.value;
noteTimer = setTimeout(function () {
fetch('/cart/update.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ note: val })
});
}, 600);
});
document.addEventListener('change', function (e) {
if (!e.target.matches || !e.target.matches('[data-cart-pickup]')) return;
var val = e.target.value;
$$('[data-cart-pickup]').forEach(function (r) { r.checked = (r.value === val); });
fetch('/cart/update.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ attributes: { 'Pickup location': val } })
});
});
var stalePickup = $$('[data-cart-pickup-clear]');
if (stalePickup.length) {
fetch('/cart/update.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ attributes: { 'Pickup location': '' } })
}).then(function (r) {
if (r.ok) stalePickup.forEach(function (el) { el.remove(); });
}, function () {});
}
drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && !drawer.hidden) close();
});
}
function initMaps() {
$$('[data-map-load]').forEach(function (btn) {
btn.addEventListener('click', function () {
var slot = btn.closest('.location').querySelector('[data-map-slot]');
if (!slot || slot.querySelector('iframe')) return;
var frame = document.createElement('iframe');
frame.src = 'https://www.google.com/maps?q=' + btn.getAttribute('data-query') + '&output=embed';
frame.loading = 'lazy';
frame.title = 'Map';
frame.referrerPolicy = 'no-referrer-when-downgrade';
frame.setAttribute('allowfullscreen', '');
slot.innerHTML = '';
slot.appendChild(frame);
btn.hidden = true;
});
});
}
function initOpenStatus() {
var pills = document.querySelectorAll('[data-open-status]');
if (!pills.length || typeof Intl === 'undefined' || !Intl.DateTimeFormat) return;
var DAY = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
Array.prototype.forEach.call(pills, function (el) {
var tz = el.getAttribute('data-tz');
var opens = parseInt(el.getAttribute('data-opens'), 10);
var closes = parseInt(el.getAttribute('data-closes'), 10);
var days = (el.getAttribute('data-days') || '').split(',');
if (!tz || isNaN(opens) || isNaN(closes)) return;
var parts;
try {
parts = new Intl.DateTimeFormat('en-US', {
timeZone: tz, weekday: 'short', hour: '2-digit',
minute: '2-digit', hour12: false
}).formatToParts(new Date());
} catch (err) {
return;                       // bad zone: keep what the server said
}
var got = {};
parts.forEach(function (p) { got[p.type] = p.value; });
var closed = (el.getAttribute('data-closed-dates') || '').split(',');
if (closed.length && closed[0]) {
var ymd;
try {
ymd = new Intl.DateTimeFormat('en-CA', {
timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit'
}).format(new Date());
} catch (err) { ymd = null; }
if (ymd && closed.indexOf(ymd) !== -1) {
var shut = el.querySelector('[data-open-status-text]');
el.classList.remove('oh--open');
if (shut) { shut.textContent = el.getAttribute('data-label-closed'); }
return;
}
}
var hour = parseInt(got.hour, 10) % 24;
var mins = hour * 60 + parseInt(got.minute, 10);
var dow = DAY[got.weekday];
if (isNaN(mins) || dow === undefined) return;
var open = days.indexOf(String(dow)) !== -1 && mins >= opens && mins < closes;
var text = el.querySelector('[data-open-status-text]');
el.classList.toggle('oh--open', open);
if (text) {
text.textContent = el.getAttribute(open ? 'data-label-open' : 'data-label-closed');
}
});
}
function init() {
[initMaps, initCart, initRail, initRailAuto, initGangCalc, initFacets, initProduct,
initMegaMenu, initDrawer, initReveal, initCutoff, initSameDay, initConsent, initSticky,
initHeaderHeight, initOpenStatus]
.forEach(function (fn) {
try {
fn();
} catch (err) {
if (window.console && console.error) {
console.error('[dtfv] ' + (fn.name || 'init') + ' failed to bind:', err);
}
}
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();
(function () {
var root = document.querySelector('[data-storefront-search]');
if (!root) return;
var field = root.querySelector('[data-psearch-input]'), box = root.querySelector('[data-psearch-results]');
var timer, abort, rev = 0, at = -1, links = [];
function close() {
rev++; clearTimeout(timer);
if (abort) abort.abort();
box.hidden = true; field.setAttribute('aria-expanded', 'false');
field.removeAttribute('aria-activedescendant'); at = -1;
}
function url(value, image) {
try { var u = new URL(value, location.origin); if (!/^https?:$/.test(u.protocol)) return ''; if (image) u.searchParams.set('width', '96'); return u.href; } catch (e) { return ''; }
}
function node(tag, text) { var el = document.createElement(tag); if (text) el.textContent = text; return el; }
function link(title, href, image) {
var a = node('a'); a.href = href; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false');
a.id = 'SearchOption' + links.length; a.tabIndex = -1;
if (image) { var img = node('img'); img.src = image; img.alt = ''; img.width = 40; img.height = 40; a.appendChild(img); }
a.appendChild(node('span', title)); links.push(a); return a;
}
field.addEventListener('input', function () {
close(); var stamp = rev, q = field.value.trim(); if (q.length < 2) return;
timer = setTimeout(function () {
abort = new AbortController();
fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,article&resources[limit]=5', { signal: abort.signal })
.then(function (r) { if (!r.ok) throw 0; return r.json(); })
.then(function (data) {
if (stamp !== rev || field.value.trim() !== q) return;
box.replaceChildren(); links = []; at = -1;
var dataResults = data.resources.results;
['products', 'pages', 'articles'].forEach(function (kind) {
if (!dataResults[kind].length) return;
var head = node('h3', root.dataset[kind]), list = node('ul'); list.className = 'psearch__list';
list.setAttribute('role', 'group'); list.setAttribute('aria-label', root.dataset[kind]); head.setAttribute('aria-hidden', 'true');
dataResults[kind].forEach(function (item) {
var href = url(item.url); if (!href) return;
var li = node('li'); li.setAttribute('role', 'presentation');
li.appendChild(link(item.title, href, item.image ? url(item.image, true) : '')); list.appendChild(li);
}); box.append(head, list);
});
if (!links.length) { var empty = node('p', root.dataset.empty.replace('__QUERY__', q)); empty.className = 'psearch__empty'; box.appendChild(empty); }
var all = link(root.dataset.all, root.querySelector('form').action + '?q=' + encodeURIComponent(q) + '&options[prefix]=last'); all.className = 'psearch__all'; box.appendChild(all);
box.hidden = false; field.setAttribute('aria-expanded', 'true');
}).catch(function () {});
}, 220);
});
field.addEventListener('keydown', function (e) {
if (e.key === 'Escape') { e.preventDefault(); close(); return; }
if (box.hidden) return;
if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
e.preventDefault(); if (at >= 0) links[at].setAttribute('aria-selected', 'false');
at = at < 0 ? (e.key === 'ArrowDown' ? 0 : links.length - 1) : (at + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
links[at].setAttribute('aria-selected', 'true'); field.setAttribute('aria-activedescendant', links[at].id); links[at].scrollIntoView({ block: 'nearest' });
} else if (e.key === 'Enter' && at >= 0) { e.preventDefault(); links[at].click(); }
else if (e.key === 'Tab') close();
});
document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
})();
